export const AppFooter = () => {
  return <footer className="main-footer-container">
    Made by Amit Akuka
  </footer>
}